/**
 * MSW inline responses for the "Add Jamie transcript" sales-call flow and the video-call meeting
 * detail (`/apollo/company-meetings/*`). Spread into the ENV-wide map in `inlineResponses.tsx`.
 * Hand-authored demo data (invented names, synthetic ids).
 */
export const COMPANY_MEETINGS_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // The current user's recent Jamie meetings, offered in the picker.
  "/apollo/company-meetings/recent-meetings": [
    {
      jamieMeetingId: "jm-company-0001",
      title: "Video call — Energy Network Services",
      meetingDate: "2026-07-20T17:00:00Z",
    },
    {
      jamieMeetingId: "jm-company-0002",
      title: "Discovery — Prairie Steel Fabricators",
      meetingDate: "2026-07-18T15:30:00Z",
    },
  ],

  // POST preview — the parsed meeting for the review step.
  "/apollo/company-meetings/preview": {
    companyId: "11111111-1111-4111-8111-111111111111",
    jamieMeetingId: "jm-company-0001",
    jamieUrl: "https://app.meetjamie.ai/meetings/jm-company-0001",
    title: "Video call — Energy Network Services",
    meetingDate: "2026-07-20T17:00:00Z",
    summaryShort:
      "Discovery call: ~40 LTL shipments/month, unhappy with current broker's tracking.",
    summaryMarkdown:
      "# Video call — Energy Network Services\n\nDiscovery call with Victor Van. They ship roughly 40 LTL loads a month across Western Canada and are unhappy with their current broker's tracking.\n\n**Next step:** send pricing for their top 5 lanes.",
    participants: [
      { name: "Rep", email: "rep@freightsimple.com" },
      { name: "Victor Van", email: "victor@example.com" },
    ],
    proposedActionItems: [
      {
        content: "Send pricing for their top 5 lanes",
        defaultAssignee: "rep@freightsimple.com",
      },
      { content: "Share tracking demo video", defaultAssignee: "" },
    ],
  },

  // Snapshot list for a company (not surfaced in the UI yet, but the endpoint exists).
  "/apollo/company-meetings/for-company": [
    {
      companyMeetingId: "cm100000-0000-4000-8000-000000000001",
      title: "Video call — Energy Network Services",
      meetingDate: "2026-07-20T17:00:00Z",
      summaryShort:
        "Discovery call: ~40 LTL shipments/month, unhappy with current broker's tracking.",
      createdAt: "2026-07-20T18:05:00Z",
      createdBy: "rep@freightsimple.com",
    },
  ],

  // Full snapshot for the meeting detail dialog.
  "/apollo/company-meetings/cm100000-0000-4000-8000-000000000001": {
    companyMeetingId: "cm100000-0000-4000-8000-000000000001",
    companyId: "11111111-1111-4111-8111-111111111111",
    jamieMeetingId: "jm-company-0001",
    jamieUrl: "https://app.meetjamie.ai/meetings/jm-company-0001",
    title: "Video call — Energy Network Services",
    meetingDate: "2026-07-20T17:00:00Z",
    summaryMarkdown:
      "# Video call — Energy Network Services\n\nDiscovery call with Victor Van. They ship roughly 40 LTL loads a month across Western Canada and are unhappy with their current broker's tracking.\n\n**Next step:** send pricing for their top 5 lanes.",
    summaryShort:
      "Discovery call: ~40 LTL shipments/month, unhappy with current broker's tracking.",
    transcript:
      "Rep\n\n00:00 - 00:05\n\nThanks for making time, Victor. Tell me about your current freight setup.\n\nVictor\n\n00:05 - 00:30\n\nWe ship about 40 LTL loads a month, mostly BC and Alberta. Tracking with our current broker is a black hole.",
    participantsJson:
      '[{"name":"Rep","email":"rep@freightsimple.com"},{"name":"Victor Van","email":"victor@example.com"}]',
    actionItemsJson:
      '[{"content":"Send pricing for their top 5 lanes","completed":false,"assignee":{"name":"Rep","email":"rep@freightsimple.com"}},{"content":"Share tracking demo video","completed":false}]',
    createdBy: "rep@freightsimple.com",
  },
};
